const initialState = {
    fetching: false,
    fetched: false,
    tags: [],
    categories: [],
    sources:[],
    error: null,
};

const reducer = (state = initialState, {type, payload}) => {
    switch (type) {
        case 'TAGS_FETCHING':
            state = {...state, ...{fetching: true}};
            break;
        case 'TAGS_ERROR':
            state = {...state, ...{error: payload.error, fetched: true}};
            break;

        case 'TAGS_FETCHED':
            state = {...state, ...{tags: payload, fetching: false, fetched: true}};
            break;
        case 'CATEGORY_FETCHING':
            state = {...state, ...{fetching: true}};
            break;
        case 'CATEGORY_ERROR':
            state = {...state, ...{error: payload.error, fetched: true}};
            break;

        case 'CATEGORY_FETCHED':
            state = {...state, ...{categories: payload, fetching: false, fetched: true}};
            break;
        case 'SOURCE_FETCHING':
            state = {...state, ...{fetching: true}};
            break;
        case 'SOURCE_ERROR':
            state = {...state, ...{error: payload.error, fetched: true}};
            break;

        case 'SOURCE_FETCHED':
            state = {...state, ...{sources: payload, fetching: false, fetched: true}};
            break;
        default:
            break;
    }
    return state;
};

export default reducer;



// WEBPACK FOOTER //
// ./src/app/reducers/advancedFilter.js